import { render, staticRenderFns } from "./BackTop.vue?vue&type=template&id=e2df3570&scoped=true&"
import script from "./BackTop.vue?vue&type=script&lang=js&"
export * from "./BackTop.vue?vue&type=script&lang=js&"
import style0 from "styles/components/backtop.css?vue&type=style&index=0&id=e2df3570&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2df3570",
  null
  
)

export default component.exports